// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qnFO","colBig":"styles_colBig__cuEgK","colSmall":"styles_colSmall__2u6II","shopifyNameWrapper":"styles_shopifyNameWrapper__338AW"};